<template>
  <el-card class="calc-form">
    <h2 class="tt-up">Калькулятор перевозки</h2>
    <loader-wrapper :loading="isLoading">
      <el-row>
        <el-col :span="isMobile ? 24 : 8">
          <autocomplete-custom
            placeholder="Регион погрузки"
            name="regionLoad"
            :lib="loadConfig.regionLoad"
            :fast="false"
            :edit="edit[0]"
            @selected="setRegionLoad"
          />
          <autocomplete-custom
            placeholder="Населенный пункт погрузки"
            name="kladrLoad"
            :lib="loadConfig.kladrLoad"
            :fast="false"
            :edit="edit[1]"
            :disabled="isRegionLoad"
            style="margin-bottom: 50px"
            @selected="setLoadKladr"
          />
          <autocomplete-custom
            placeholder="Регион выгрузки"
            name="regionUnLoad"
            :lib="unloadConfig.regionUnLoad"
            :fast="false"
            :edit="edit[2]"
            @selected="setRegionUnLoad"
          />
          <el-row class="calc-fastLinks">
            <el-link
              v-for="link in fastlinks"
              :key="link.id"
              @click="onLinkSelect(link)"
            >
              {{ link.name }}
            </el-link>
          </el-row>
          <autocomplete-custom
            placeholder="Населенный пункт выгрузки"
            name="kladrUnLoad"
            :lib="unloadConfig.kladrUnLoad"
            :fast="false"
            :edit="edit[3]"
            :disabled="isRegionUnLoad"
            @selected="setUnLoadKladr"
          />
        </el-col>
        <el-col :span="isMobile ? 24 : 11" class="calc-map">
          <calc-y-map
            :load="points.load_point"
            :unload="points.unload_point"
            @distance="setDistance"
            @loading="setLoading"
          />
        </el-col>
        <el-col :span="isMobile ? 24 : 5" class="calc-distance">
          <el-input-number
            v-model="points.distance"
            :min="0"
            :controls="false"
            placeholder="Расстояние, км"
          />
          <p>Вы можете скорректировать расстояние, км</p>
        </el-col>
      </el-row>
    </loader-wrapper>
    <el-col :span="isMobile ? 24 : 8" class="calc-btns">
      <el-row :gutter="40">
        <el-col :span="12">
          <el-button type="primary" :loading="isLoading" @click="onClear">
            Сбросить
          </el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" :loading="isLoading" @click="onCalculate">
            Рассчитать
          </el-button>
        </el-col>
      </el-row>
    </el-col>
  </el-card>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import {
  autocompleteSettingsOne,
  autocompleteSettingsTwo,
} from '@/datas/consts'
import { fastlinks } from '../constants'
import { mapActions, mapGetters } from 'vuex'
import AutocompleteCustom from '@/components/Forms/AutocompleteCustom'
import CalcYMap from '@/components/Maps/CalcYMap'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'CalculatorForm',
  components: { CalcYMap, AutocompleteCustom, LoaderWrapper },
  data() {
    return {
      fastlinks,
      points: {
        load_point: '',
        load_point_kladr_id: '',
        unload_point: '',
        unload_point_kladr_id: '',
        distance: undefined,
      },
      edit: {},
      loading: false,
      load_point_region: {},
      unload_point_region: {},
      loadConfig: autocompleteSettingsOne,
      unloadConfig: autocompleteSettingsTwo,
    }
  },
  computed: {
    ...mapGetters('bids', ['getLoading']),
    isLoading() {
      return this.loading || this.getLoading('Calc')
    },
    isRegionLoad() {
      return !this.loadConfig.kladrLoad.params.regionId
    },
    isRegionUnLoad() {
      return !this.unloadConfig.kladrUnLoad.params.regionId
    },
  },
  methods: {
    ...mapActions('bids', ['fetchCalcResults']),
    setLoading(flag) {
      this.loading = flag
    },
    setDistance(val = undefined) {
      this.points.distance = val
    },
    onLinkSelect(item) {
      const { name, id, region, relation } = item

      this.edit = {
        ...this.edit,
        2: { name: region, id: relation, fast: true },
        3: { name, id },
      }
    },
    setRegionLoad(item) {
      this.loadConfig.kladrLoad.params.regionId = item.id
      this.load_point_region = item
      this.setDistance()

      if (this.points.load_point) {
        this.edit[1] = { clear: true }
        this.points.load_point_kladr_id = ''
        this.points.load_point = ''
      }
    },
    setLoadKladr(item) {
      this.setDistance()
      this.points.load_point_kladr_id = item.id
      this.points.load_point = item.name
        ? this.load_point_region.name + ',' + item.name
        : ''
    },
    setRegionUnLoad(item, fast = false) {
      this.unloadConfig.kladrUnLoad.params.regionId = item.id
      this.unload_point_region = item
      this.setDistance()

      if (this.points.unload_point && !fast) {
        this.edit[3] = { clear: true }
        this.points.unload_point = ''
        this.points.unload_point_kladr_id = ''
      }
    },
    setUnLoadKladr(item) {
      this.setDistance()
      this.points.unload_point_kladr_id = item.id
      this.points.unload_point = item.name
        ? this.unload_point_region.name + ',' + item.name
        : ''
    },
    onCalculate() {
      const { distance, load_point_kladr_id, unload_point_kladr_id } =
        this.points

      if (!distance || !load_point_kladr_id || !unload_point_kladr_id) {
        this.$message.error('Заполните все поля')
      } else {
        this.fetchCalcResults({
          distance,
          load_point_kladr_id,
          unload_point_kladr_id,
        })
      }
    },
    onClear() {
      this.edit = {
        0: { clear: true },
        1: { clear: true },
        2: { clear: true },
        3: { clear: true },
      }
    },
  },
}
</script>

<style lang="sass">
.calc-form
  .calc-fastLinks
    margin: 20px 0
    .el-link.el-link--default
      color: #409EFF
      border-bottom: 1px solid #409EFF
      &:hover
        border: none
    a + a
      margin-left: 25px
  .calc-map
    padding: 18px 45px 0
  .calc-distance
    margin-top: 1em
    .el-input-number
      width: 100%
  .calc-btns
    margin: 40px 0 30px
    button
      width: 100%
.calc-mob .calc-form
  .calc-map
    padding: 25px 0
  .calc-btns
    margin: 20px 0
</style>
